export default __webpack_public_path__ + "static/media/pic90.abe80106.jpg";